import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from 'src/app/core/config/configuration.service';

@Injectable()
export class GroupProxy {
    constructor(
        private http: HttpClient,
        private configurationService: ConfigurationService,
    ) {}

    async getGroup(id: string): Promise<GroupDTO> {
        const url = this.configurationService.APIURL + '/api/groups/' + id;
        return await this.http.get<GroupDTO>(url).toPromise();
    }

    async getGroups(searchString?: string): Promise<GroupSummaryDTO[]> {
        let url = this.configurationService.APIURL + '/api/groups';
        if (searchString) {
            url += '?searchString=' + encodeURIComponent(searchString);
        }
        return await this.http.get<GroupSummaryDTO[]>(url).toPromise();
    }

    async getGroupDetails(id: string): Promise<GroupDetailsDTO> {
        const url = this.configurationService.APIURL + '/api/groups/' + id + '/details';
        return await this.http.get<GroupDetailsDTO>(url).toPromise();
    }

    async createGroup(dto: CreateGroupDTO): Promise<string> {
        const url = this.configurationService.APIURL + '/api/groups';
        return await this.http.post<string>(url, dto).toPromise();
    }

    async updateGroup(id: string, dto: UpdateGroupDTO): Promise<void> {
        const url = this.configurationService.APIURL + '/api/groups/' + id;
        await this.http.put<void>(url, dto).toPromise();
    }

    async groupNameExists(name: string): Promise<boolean> {
        const url = this.configurationService.APIURL + '/api/groups/any/name?name=' + encodeURIComponent(name);
        return await this.http.get<boolean>(url).toPromise();
    }
}

export interface GroupDTO {
    name: string;
    language: string;
    countryCode: string;
}

export interface GroupSummaryDTO {
    id: string;
    name: string;
    countryCode: string;
    language: string;
    nbPractices: number;
    createdOn: string;
}

export interface GroupDetailsDTO {
    id: string;
    name: string;
    language: string;
    countryCode: string;
    street: string;
    streetNumber: string;
    postalCode: string;
    city: string;
    phoneNumber: string;
    notes: string;
    managers: GroupDetailsManagerDTO[];
    practices: { id: string; name: string; debtorNumber: string }[];
}

export interface GroupDetailsManagerDTO {
    firstName: string;
    lastName: string;
    email: string;
    lastLogin: string | null;
}

export interface CreateGroupDTO {
    name: string;
    countryCode: string;
    language: string;
}

export interface UpdateGroupDTO {
    name: string;
    language: string;
    countryCode: string;
    street: string;
    streetNumber: string;
    postalCode: string;
    city: string;
    phoneNumber: string;
    notes: string;
}
